import { useEffect, useState } from 'react';
import { useAccount } from '../app/account-context';
import { notify } from '../components/basic/notify';
import { attachmentApi } from '../api/attachment-api';

const empty_image =
    'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

export const useImage = (url: string) => {
    const account = useAccount();
    const [imageInfo, setImageInfo] = useState<{ url?: string; data: any }>();

    function arrayBufferToBase64(buffer: any) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    const refresh = () => {
        attachmentApi
            .getImage(url)
            .then(x => {
                var data = `data:${x.headers['content-type']};base64,${arrayBufferToBase64(x.data)}`;
                setImageInfo({ url, data });
            })
            .catch(notify.error);
    };

    useEffect(() => {
        if (!account.connected) return;
        if (url && imageInfo?.url === url) return;
        setImageInfo({ ...imageInfo, data: empty_image });
        refresh();
    }, [url, account.connected]);

    return {
        data: imageInfo?.data ?? empty_image,
        refresh,
    };
};
